/* eslint-disable max-len */
import { Injectable } from '@angular/core';

import { MuHttpService } from './mu-http.service';
import { environment } from 'src/environments/environment';
import { HttpStatusCode } from '@angular/common/http';
import {
  Companies,
  RespAssociated,
} from '../../operations/models/interface/resp-associated-companies.interface';

@Injectable({
  providedIn: 'root',
})
export class CompanyUserService {
  constructor(private muHttp: MuHttpService) {}

  /**
   *
   * @param companyId
   * @returns
   */
  getAssociatedCompanies(companyId: string): Promise<Companies[]> {
    return new Promise((resolve, reject) => {
      this.muHttp
        .get(`${environment.hostInternal}/company/companies-asociated/${companyId}`)
        .subscribe({
          next: (res: RespAssociated) => {
            if (res.status_code === HttpStatusCode.Ok) {
              return resolve(res.data);
            }
            return reject(res?.error?.message || res);
          },
          error: err => reject(err),
        });
    });
  }
}
